import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { ToasterService } from 'angular2-toaster';
import 'rxjs/add/operator/toPromise';

import { CashReceiptModel } from '../model/index';

@Injectable()
export class CashReceiptService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private cashReceiptUrl = 'api/cashReceipt';  // URL to web api

    constructor(private http: Http, public toasterService: ToasterService) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getCashReceiptList(query: any): Promise<CashReceiptModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cashReceiptUrl}/getCashReceiptList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getCashReceiptDetailList(query: any): Promise<CashReceiptModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.cashReceiptUrl}/getCashReceiptDetailList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData,
            // Errors will call this callback instead:
            err => {
                var toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: 'Something went wrong, Please Contact System Admin'
                };
                this.toasterService.pop(toast);
            })
            .catch(this.handleError);
    }
    
    deleteCashReceiptentry(rowData: any): Promise<CashReceiptModel> {
        const url = `${this.cashReceiptUrl}/deleteCashReceiptentry`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as CashReceiptModel)
            .catch(this.handleError);
    }

    addCashReceiptentry(pageData: any): Promise<any> {
        const url = `${this.cashReceiptUrl}/addCashReceiptentry`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);

    }
    getPendingClient(data: any): Promise<CashReceiptModel[]> {
     
        const url = `${this.cashReceiptUrl}/getPendingClient`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }


    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/cashReceipt.service.ts